import { observer } from "mobx-react-lite";
import { ReactComponent as Logo } from "../images/Logo.svg";
import { ReactComponent as LogoBlack } from "../images/LogoBlack.svg";
import { ReactComponent as Arrow } from "../images/arrow.svg";
import { ReactComponent as Close } from "../images/close.svg";
import { ReactComponent as Burger } from "../images/burger.svg";

import "../styles/index.css";
import gsap from "gsap";
import { ScrollToPlugin, ScrollTrigger } from "gsap/all";
import { useEffect, useState } from "react";
import Welcome from "../components/blocks/Welcome";
import How from "../components/blocks/How";
import Algorithm from "../components/blocks/Algorithm";
import Rates from "../components/blocks/Rates";
import Questions from "../components/blocks/Questions";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)
gsap.core.globals("ScrollTrigger", ScrollTrigger)
const Main = () => {
    const [mobileMenu, setMobileMenu] = useState(false);

    // useEffect(() => {
    //     let ctx = gsap.context(() => {
            // gsap.to(elMob3.current, {
			// 	scrollTrigger: {
			// 		trigger: ".whyBitrix",
			// 		endTrigger: ".stages",
			// 		start: "bottom top",
			// 		end: "bottom top",
			// 		toggleClass: {
			// 			targets: elMob3.current, 
			// 			className: "active",
			// 		}
			// 	},
			// })
    //     });
	// 	return () => ctx.revert();
    // }, []);

    const scrollToBlock = (classBlock) => {
        setMobileMenu(false);
		gsap.to(window, { duration: 1, scrollTo: `.${classBlock}` });
	}

    return (
        <>
            <header>
                <div className="logo"><Logo/></div>
                <ul className="menu">
                    <li onClick={() => scrollToBlock("how")}>Преимущества</li>
                    <li onClick={() => scrollToBlock("algorithm")}>Как работает?</li>
                    <li onClick={() => scrollToBlock("rates")}>Тарифы</li>
                    {/* <li onClick={() => scrollToBlock("feedback")}>Отзывы</li> */}
                    <li onClick={() => scrollToBlock("questions")}>FAQ</li>
                </ul>
                <div className="buttons">
                    <button className="activeButton" onClick={() => window.location.href = "https://calc.financeprice.ru/"}>
                        <div className="text">Перейти</div>
                        <Arrow/>
                    </button>
                    <button className="defaultButton" onClick={() => setMobileMenu(true)}><Burger/></button>
                </div>
            </header>
            <div className={`burgerMenu${mobileMenu ? " opened" : ""}`}>
                <div className="content">
                    <div className="topBlock">
                        <div className="logo"><LogoBlack/></div>
                        <button className="activeButton" onClick={() => setMobileMenu(false)}><Close/></button>
                    </div>
                    <ul>
                        <li>
                            <ul className="links">
                                <li>
                                    <a onClick={() => scrollToBlock("how")}>Преимущества</a>
                                    <a onClick={() => scrollToBlock("algorithm")}>Как работает?</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <ul className="links">
                                <li>
                                    <a onClick={() => scrollToBlock("rates")}>Тарифы</a>
                                    {/* <a href="">Отзывы</a> */}
                                </li>
                                <li>
                                    <a onClick={() => scrollToBlock("questions")}>FAQ</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <div className="bottomBlock">
                        <ul className="links">
                            <li>
                                <a link="https://t.me/Valerija_finance">Telegram</a>
                                <a link="https://dzen.ru/balansstandart">Яндекс Дзен</a>
                                <a link="https://dzen.ru/balansstandart">ВКонтакте</a>
                            </li>
                            <li>
                                <a href="" className="email">no-reply@financeprice.online</a>
                                <a>8 (918) 196-81-90</a>
                            </li>
                        </ul>
                        <button className="activeButton">
                            <div className="text">Попробовать бесплатно</div>
                            <Arrow/>
                        </button>
                    </div>
                </div>
            </div>
            <Welcome/>
            <How/>
            <Algorithm/>
            <Rates/>
            <div className="feedback">
                <div className="naming">Отзывы</div>
                <h2>Что говорят пользователи?</h2>
                <div className="navigation">
                    <button className="prev"><Arrow/></button>
                    <button className="next"><Arrow/></button>
                </div>
                <div className="viewer">
                    <ul className="slider">
                        <li>
                            <div className="image"></div>
                            <div className="content">
                                <div className="text">«Раньше расчет услуг занимал 20–30 минут, теперь – 2 клика. Клиенты в восторге от прозрачности!»</div>
                                <div className="desc">
                                    <div className="name">Анна</div>
                                    <div className="info">Бухглатер с 10-летним опытом</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <Questions/>
            <footer>
                <div className="content">
                    <div className="logo"><LogoBlack/></div>
                    <ul className="links">
                        <li>
                            <div className="title">[Контакты]</div>
                            <div className="linksList">
                                <a>no-reply@financeprice.online</a>
                                <a>8 (918) 196-81-90</a>
                                <a link="https://t.me/Valerija_finance">Telegram</a>
                                <a link="https://dzen.ru/balansstandart">Яндекс Дзен</a>
                                <a link="https://dzen.ru/balansstandart">ВКонтакте</a>
                            </div>
                        </li>
                        <li>
                            <div className="title">[Навигация]</div>
                            <div className="linksList">
                                <a onClick={() => scrollToBlock("how")}>Преимущества</a>
                                <a onClick={() => scrollToBlock("algorithm")}>Как работает?</a>
                                <a onClick={() => scrollToBlock("rates")}>Тарифы</a>
                                {/* <a>Отзывы</a> */}
                                <a onClick={() => scrollToBlock("questions")}>FAQ</a>
                            </div>
                        </li>
                        <li>
                            <div className="title">[Документы]</div>
                            <div className="linksList">
                                <a href="/offerta.pdf">Оферта</a>
                                <a href="/card FinPrice.pdf">Реквизиты компании</a>
                                {/* <a>Пользовательское соглашение</a> */}
                                <a href="/politika.pdf">Политика конфиденциальности</a>
                            </div>
                        </li>
                        <li>
                            <div className="title">[ИНН]</div>
                            <div className="linksList"><a>505101094167</a></div>
                        </li>
                        <li>
                            <div className="title">[ОГРНИП]</div>
                            <div className="linksList"><a>320237500261825</a></div>
                        </li>
                        <li>
                            <div className="title">[Наш офис]</div>
                            <div className="linksList"><a>Краснодар, улица 40-летия победы, д. 34, офис 702</a></div>
                        </li>
                    </ul>
                </div>
                <div className="copyright">© 2025 Finprice. ИП Кобракова Валерия Владимировна. Все права защищены.</div>
            </footer>
        </>
    )
}

export default observer(Main);